module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-BookItalic-76fc043731c5fcd088ca9fa5057eeff8.otf";